import { baseApi } from "@/shared/api";
import type { ChatChannel, CreateChatChannelDto, UpdateChatChannelDto } from "../types";

export const chatChannelsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getChatChannels: builder.query<ChatChannel[], void>({
      query: () => ({ url: "/api/chat/channels/", method: "GET", credentials: "include" as const }),
      providesTags: [{ type: "ChatChannels", id: "LIST" }],
    }),
    createChatChannel: builder.mutation<ChatChannel, CreateChatChannelDto>({
      query: (body) => ({ url: "/api/chat/channels/", method: "POST", body, credentials: "include" as const }),
      invalidatesTags: [{ type: "ChatChannels", id: "LIST" }],
    }),
    updateChatChannel: builder.mutation<ChatChannel, { id: number; data: UpdateChatChannelDto }>({
      query: ({ id, data }) => ({
        url: `/api/chat/channels/${id}/`,
        method: "PATCH",
        body: data,
        credentials: "include" as const,
      }),
      invalidatesTags: [{ type: "ChatChannels", id: "LIST" }],
    }),
    deleteChatChannel: builder.mutation<void, number>({
      query: (id) => ({ url: `/api/chat/channels/${id}/`, method: "DELETE", credentials: "include" as const }),
      invalidatesTags: [{ type: "ChatChannels", id: "LIST" }],
    }),
  }),
});

export const {
  useGetChatChannelsQuery,
  useCreateChatChannelMutation,
  useUpdateChatChannelMutation,
  useDeleteChatChannelMutation,
} = chatChannelsApi;
